

var fn_hide_streak = function () {
    $('.m-card-citation').each( function() {
         $(this).prev(".lead__wrapper").addClass("no-streak")
    } )
}